import { SET_COURSES, UPDATE_COURSE } from './actions';

const INITIAL_STATE = null;

const courseReducer = (state = INITIAL_STATE, action) => {
     switch (action.type) {
          case SET_COURSES: {
               return action.payload;
          }
          case UPDATE_COURSE: {
               const courses = [...state];
               const newCourse = courses.map((course) => {
                    if (course.id === action.payload.id) {
                         return { ...course, ...action.payload };
                    }
                    return course;
               });
               return newCourse;
          }
          default:
               return state;
     }
};

export default courseReducer;
